export default __webpack_public_path__ + "static/media/PrivacyPolicyPage.3370ad67.jpeg";